import React from "react";
import { Button, Snackbar, SnackbarContent } from "@mui/material";

export const UpdatePwa = ({ handleOpen, handleClose }) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={handleOpen}
      onClose={handleClose}
    >
      <SnackbarContent
        style={{ backgroundColor: "#0099d8" }}
        message={<span id="client-snackbar">A new version is available!!</span>}
        action={
          <Button color="primary" size="small" onClick={handleClose}>
            Update now
          </Button>
        }
      />
    </Snackbar>
  );
};
